import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";

import Table from "./Table";

function Stats(props) {
  const { request, filters } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const { results = [] } = data;

  const performRequest = useCallback(() => {
    request({ ...filters, limit: 3 }).then(response => {
      setIsLoading(false);
      setData(response.data);
    });
  }, []);

  useEffect(() => {
    performRequest();
  }, []);

  return (
    <Table
      isLoading={isLoading}
      results={results}
      refresh={performRequest}
      {...props}
    />
  );
}

Stats.propTypes = {
  request: PropTypes.func.isRequired,
  filters: PropTypes.instanceOf(Object)
};

export default Stats;



// WEBPACK FOOTER //
// ./app/modules/HighScores/components/StatsTable/SearchStats.jsx